import { usePlacesOfPaymentQuery } from 'modules/root';
import { useQueryPaymentModels } from 'modules/settings/hooks';

export const useCalculationPaymentMethodQuery = () => {
  const {
    error: errPaymentMethods,
    isLoading: isLoadingPaymentMethods,
    data: paymentModels,
  } = useQueryPaymentModels();

  const {
    isLoading: isLoadingPlacesOfPayment,
    isError: isErrorPlacesOfPayment,
    placesOfPayment,
  } = usePlacesOfPaymentQuery();

  return {
    isError: isErrorPlacesOfPayment || errPaymentMethods,
    isLoading: isLoadingPaymentMethods || isLoadingPlacesOfPayment,
    data: {
      paymentMethods: paymentModels?.map((m: any) => ({
        value: m.paymentModelId,
        label: m.paymentModelName,
      })),
      placesOfPayment: placesOfPayment?.map((item: any) => {
        const { rootId, paymentSourceCode, paymentSourceName } = item;

        return { value: +rootId, label: `${paymentSourceCode} ${paymentSourceName}` };
      }),
    },
  };
};
